<template>
  <div>
    <button class="menu-icon" @click="toggleMenu">
      <img :src="menuOpen ? '/assets/svgs/cross.svg' : '/assets/svgs/burger.svg'" alt="Menu" />
    </button>
    <div v-if="menuOpen" class="overlay" @click.self="closeMenu">
      <nav class="sidebar">
        <h1>Menu</h1>
        <ul>
          <li>
            <router-link 
              to="/aboutpage" 
              @click="closeMenu"
              active-class="current-page"
              exact-active-class="current-page"
            >Warum Laubloch?</router-link>
          </li>
          <li>
            <router-link 
              to="/accountpage" 
              @click="closeMenu"
              :class="{ 'current-page': $route.path === '/login' }"
              active-class="current-page"
              exact-active-class="current-page"
            >Account</router-link>
          </li>
          <li>
            <router-link 
              to="/" 
              @click="closeMenu"
              active-class="current-page"
              exact-active-class="current-page"
            >Bewerten</router-link>
          </li>
          <li>
            <router-link 
              to="/lochgenerator" 
              @click="closeMenu"
              active-class="current-page"
              exact-active-class="current-page"
            >Visualisieren</router-link>
          </li>
          <li>
            <router-link 
              to="/impressum" 
              @click="closeMenu"
              active-class="current-page"
              exact-active-class="current-page"
            >Impressum</router-link>
          </li>
          <li>
            <router-link 
              to="/datenschutz" 
              @click="closeMenu"
              active-class="current-page"
              exact-active-class="current-page"
            >Datenschutz</router-link>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuOpen: false,
    };
  },
  watch: {
    $route() {
      this.menuOpen = false;
    }
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
    closeMenu() {
      this.menuOpen = false;
    },
  },
};
</script>

<style scoped>
.current-page {
  font-style: italic;
}
</style>